import React, { MouseEvent, useEffect } from 'react';

import { Badge } from "@sravni/react-design-system/lib/Badge";
import { Button } from "@sravni/react-design-system/lib/Button";
import { Card } from "@sravni/react-design-system/lib/Card";
import { Icon } from "@sravni/react-design-system/lib/Icon";
import { Space } from "@sravni/react-design-system/lib/Space";
import { Text } from "@sravni/react-design-system/lib/Typography";
import { ArrowRight } from "@sravni/react-icons";
import { useIsPhone, useStyles } from '@sravni/react-utils';

import { makeMainGEvent, pushEvent } from '../../../../utils/analytics';
import {
    recentActionEventClick,
    eventLabelMap,
    recentActionEventCategory,
    recentActionEventAction,
  } from '../../constants/index';
import { ActionCardProps } from "../../types/actionCardProps";

import styles from './PrimaryActionCard.module.scss';

export const PrimaryActionCard: React.FC<ActionCardProps> = (props) => {
    const {
        className,
        link,
        hint,
        hintColor,
        description,
        icon,
        buttonVariant,
        buttonText,
        cardColor,
        product,
        isSingleCard,
        withButton,
        badgeText,
        title,
        onClose,
        onClick,
        ...rest
      } = props;

      const isPhone = useIsPhone()
      const cx = useStyles(styles);
      const hintClassnames = cx('hint', {
        [`hint-color-${hintColor}`]: hintColor,
      });

      const iconColor = cardColor;
      const iconBackground = iconColor === 'red' ? 'red' : undefined;

      const handleClick = (event: MouseEvent<HTMLDivElement>) => {
        onClick?.(event)
        pushEvent(
          makeMainGEvent({
            eventAction: recentActionEventClick,
            eventCategory: recentActionEventCategory,
            eventLabel: eventLabelMap[product],
          }),
        );
      };

      useEffect(() => {
        product &&
          pushEvent(
            makeMainGEvent({
              eventAction: recentActionEventAction,
              eventCategory: recentActionEventCategory,
              eventLabel: eventLabelMap[product],
            }),
          );
      }, [product]);

    return (
        <Card size={24} className={cx('containerCard', className)} onClick={handleClick} {...rest}>
            <Space direction="column">
                <Space className={cx('header')} align="center" justify="space-between">
                    <Text className={cx('title')} strong>{title ?? 'Продолжим?'}</Text>
                    {!isSingleCard && (
                        <Space size={4} align="center" className={cx('badge')}>
                            <Badge color="light" variant="primary" text={badgeText} />
                            <Icon className={cx('icon')}><ArrowRight/></Icon>
                        </Space>
                    )}
                </Space>
                <Card color="dark" size={16} className={cx('innerCard')}>
                    <Card size={16} className={cx('contentCard')}>
                        <Space direction="column" justify="space-between" size={12}>
                            <Space justify="space-between" align={isPhone ? 'center' : 'flex-start'}>
                                <Space size={12}>
                                    <Icon size={16} shape="round" color='dark' background={iconBackground}>
                                        {icon}
                                    </Icon>
                                    <Space direction="column" size={2}>
                                        <Text className={cx('description')} strong>{description}</Text>
                                        <Text size={12} className={hintClassnames} strong>{hint}</Text>
                                    </Space>
                                </Space>
                                <Icon className={cx('arrowRight')}><ArrowRight/></Icon>
                            </Space>
                            {(!isPhone || (isPhone && withButton)) && <Button variant={buttonVariant}>{buttonText}</Button>}
                        </Space>
                    </Card>
                </Card>
            </Space>
        </Card>
    )
}